define('shared/tnt/at',[
        '$',
        'shared/util/state',
        'shared/lib/RSVP',
        'shared/util/state/adapters/order',
        'shared/lib/console',
        'shared/initializer/form/constants',
        'shared/util/state/adapters/page',
        'shared/util/state/adapters/session',
        'shared/util/state/adapters/user'
    ],
    function (
        $,
        state,
        RSVP,
        orderAdapter,
        console,
        constants,
        pageAdapter,
        sessionAdapter,
        userAdapter
    ) {
        'use strict';

        var g = this;

        return {
            target: function(mboxName, mboxId){
                var $elem = $('#' + mboxId);
                if($elem.length === 0){
                    console.warn('tnt at.js implementation: cannot find mbox: ' + mboxId);
                    return RSVP.Resolve();
                }

                return RSVP.all([
                    state.adapters.add(orderAdapter),
                    state.adapters.add(pageAdapter),
                    state.adapters.add(sessionAdapter),
                    state.adapters.add(userAdapter)
                ])
                .then(function(){
                    return state.get(
                        constants.State.PageEtag,
                        constants.State.PageLanguage,
                        constants.State.PageMarket,
                        constants.State.SessionEtag,
                        constants.State.SessionPartnerCode,
                        constants.State.UserMemberType,
                        constants.State.OrderOfferId);
                })
                .then(function(values){
                    var pageEtag = values[0] || '';
                    var pageLanguage = values[1] || '';
                    var pageMarket = values[2] || '';
                    var sessionEtag = values[3] || '';
                    var sessionPartnerCode = values[4] || '';
                    var userMemberType = values[5] || '';
                    var orderOfferId = (Array.isArray(values[6])?values[6][0]:values[6]) || '';

                    g.adobe.target.getOffer({
                        'mbox': mboxName,
                        'success': function(offer) {
                            g.adobe.target.applyOffer({
                                'element': $elem[0],
                                'offer': offer
                            });

                            $elem.css('visibility', 'visible');
                        },
                        'error': function(status, error) {
                            $elem.css('visibility', 'visible');

                            console.error('adobe.target.getOffer error');
                            console.log(status);
                            console.log(error);
                        },
                        'params': {
                            'pageEtag': pageEtag,
                            'pageLanguage': pageLanguage,
                            'pageMarket': pageMarket,
                            'sessionEtag': sessionEtag,
                            'sessionPartnerCode': sessionPartnerCode,
                            'userMemberType': userMemberType,
                            'orderOfferId': orderOfferId
                        }
                    });
                });
            }
        };
    });
